export const OFFER_CARD_HEIGHT = 'auto';
export const OFFER_CARD_MOST_POPULAR_HEIGHT = '15rem';
export const OFFER_CARD_MOST_POPULAR_LABEL_HEIGHT = '1.5rem';
export const OFFER_CARD_HEADER_HEIGHT = '14.7rem';
export const OFFER_CARD_HEADER_HEIGHT_WITH_DISCOUNT = '12.79rem';
export const OFFER_CARD_CONTENT_HEIGHT = '15rem';
export const OFFER_CARD_FOOTER_HEIGHT = '7.5rem';
export const OFFER_CARD_FOOTER_HEIGHT_WITH_DISCOUNT = '9rem';
export const OFFER_CARD_MAX_WIDTH = '22rem';
export const OFFER_CARD_MIN_WIDTH = '18rem';
